var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.02 13.1728C24.02 12.3219 23.9436 11.5037 23.8018 10.7183H12.5V15.3601H18.9582C18.68 16.8601 17.8345 18.131 16.5636 18.9819V21.9928H20.4418C22.7109 19.9037 24.02 16.8274 24.02 13.1728Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 24.9001C15.74 24.9001 18.4564 23.8255 20.4418 21.9928L16.5636 18.9819C15.4891 19.7019 14.1145 20.1273 12.5 20.1273C9.37455 20.1273 6.72909 18.0164 5.78546 15.1801H1.77637V18.2891C3.75091 22.211 7.80909 24.9001 12.5 24.9001Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.78545 15.1801C5.54545 14.4601 5.40909 13.691 5.40909 12.9001C5.40909 12.1092 5.54545 11.3401 5.78545 10.6201V7.51099H1.77636C0.963636 9.13099 0.5 10.9637 0.5 12.9001C0.5 14.8364 0.963636 16.6692 1.77636 18.2892L5.78545 15.1801Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 5.67275C14.2618 5.67275 15.8436 6.27821 17.0873 7.4673L20.5291 4.02548C18.4509 2.08912 15.7345 0.900024 12.5 0.900024C7.80909 0.900024 3.75091 3.58912 1.77637 7.51093L5.78546 10.62C6.72909 7.78366 9.37455 5.67275 12.5 5.67275Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.a74b3c474a008b44b71157b0b6f109b6.svg";
export { ForwardRef as ReactComponent };